import React from 'react';
import { OverlayCard } from './OverlayCard';
import { getIniciativaImageProps, type IniciativaCard } from './helpers';

/**
 * Liga o view-model da faixa ao card genérico com véu.
 *
 * Mora em arquivo próprio porque os dois ramos o renderizam: o bento do
 * desktop e o carrossel do mobile (`IniciativasCarouselMobile`).
 */
export const IniciativaOverlayCard: React.FC<{
  card: IniciativaCard;
  variant: 'hero' | 'small';
  className: string;
  /** Versão compacta abaixo de `md` (carrossel do celular). */
  dense?: boolean;
  isEditMode?: boolean;
  onEditItem?: (index: number) => void;
}> = ({ card, variant, className, dense, isEditMode, onEditItem }) => (
  <OverlayCard
    // A faixa de iniciativas é h3 (aninhada sob o h2 invisível da seção),
    // então o título do card entra um nível abaixo.
    as="h4"
    badge={card.badge}
    title={card.title}
    description={card.description}
    href={card.href}
    external={card.external}
    alt={card.alt}
    image={getIniciativaImageProps(card, variant)}
    size={variant === 'hero' ? 'hero' : 'compact'}
    className={className}
    dense={dense}
    eager={variant === 'hero'}
    isEditMode={isEditMode}
    onEdit={onEditItem ? () => onEditItem(card.sourceIndex) : undefined}
  />
);

export default IniciativaOverlayCard;
